import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Typography } from '@getgo/chameleon-web-react-wrapper';
import classes from './notification-view.scss';
import { Box } from '@mui/material';

const Notification = ({
  toastrType,
  toastrMessage,
  toastrMessageId,
}) => {
  return (
    <Box
      data-testid="notification-view"
      key={toastrMessageId}
      className={classes["notificationBlock"]}
    >
      <Snackbar>
        <Typography variant="body-small" color="type-color-inverted">
          {`${toastrMessage}`}
        </Typography>
      </Snackbar>
    </Box>
  );
};

Notification.propTypes = {
  toastrType: PropTypes.string.isRequired,
  toastrMessage: PropTypes.string.isRequired,
  toastrMessageId: PropTypes.string.isRequired,
};

export default Notification;
